<template>
  <virtual-list class="list-infinite scroll-touch"
                :data-key="dataKey"
                :data-sources="getSources()"
                :data-component="getWrapper()"
                :estimated-size="estimated"
                @totop="onScrollToTop"
                @tobottom="onScrollToBottom"
                :page-mode="true"
                ref="vsl">
    <!--div slot="footer" class="loading-spinner" v-show="onBottom && !finished">Loading...</div-->
  </virtual-list>
</template>

<script>
import virtualList from 'vue-virtual-scroll-list';
import FavoriteUserWrapper from '@/components/home/shared/FavoriteUserWrapper';
import ChatUserWrapper from '@/components/home/shared/ChatUserWrapper';

export default {
  name: 'virtual-scroll-list',
  props: {
    items: {
      type: Array,
      required: true,
    },
    dataKey: {
      type: String,
      required: true,
    },
    estimated: {
      type: Number,
    },
    wrapperType: {
      type: String,
      required: true,
    },
    remain: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      page: 0,
      finished: false,
      onBottom: false,
      wrapperTypes: {
        FAVORITE_USER: 'favorite_user',
        HISTORY_USER: 'history_user',
        CHAT_USER: 'chat_user',
      },
    };
  },
  components: {
    VirtualList: virtualList,
  },
  methods: {
    getWrapper() {
      const { FAVORITE_USER, CHAT_USER } = this.wrapperTypes;
      switch (this.wrapperType) {
      case FAVORITE_USER: return FavoriteUserWrapper;
      case CHAT_USER: return ChatUserWrapper;
      default: return FavoriteUserWrapper;
      }
    },
    getSources() {
      return this.items
        .filter((user, index) => index <= (this.page * this.remain) + this.remain);
    },
    onScrollToBottom() {
      // this.onBottom = true
      if (((this.page + 1) * this.remain) + this.remain >= this.items.length) this.page = this.page + 1;
      else this.finished = true;
      /* this.$nextTick(() => {
         this.onBottom = false
      }); */
    },
    onScrollToTop() {
      // if ((this.page - 1) * this.remain <= 0) this.page = this.page - 1;
      // else this.finished = true;
    },
    setVirtualListToIndex(index) {
      if (this.$refs.vsl) {
        this.$refs.vsl.scrollToIndex(index);
      }
    },
    setVirtualListToOffset(offset) {
      if (this.$refs.vsl) {
        this.$refs.vsl.scrollToOffset(offset);
      }
    },
    setVirtualListToBottom() {
      if (this.$refs.vsl) {
        this.$refs.vsl.scrollToBottom();
      }
    },
    checkOverFlow() {
      const vsl = this.$refs.vsl;
      if (vsl) {
        this.overflow = vsl.getScrollSize() > vsl.getClientSize();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/shared/VirtualScrollList.vue